import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { bteqCodeConversionChunkApi, bteqCodeSummaryApi, convertCodeApi, githubLinkApi, iterationApi } from "../../end-points/codeConversion";
import { toast } from "react-toastify";
import loadingMessages from "../../common/loadingMessages";

const initialState = {
  targetCode: "",
  judgeResponse: "",
  validationMessage: "",
  loading: false,
  loadingMessage: undefined,
  message: "",
  iteration: false,
  bteqChange: undefined,
  sourceCode: "",
  tdd: "",
  clonedRepo: [],
  updateStepperLoad: false,
  fileResults: [],
  fileContent: [],
}

export const githubLink = createAsyncThunk(
  "codeConversion/githubLink", githubLinkApi
)

export const convertCode = createAsyncThunk(
  "codeConversion/convertCode", convertCodeApi
)

export const iteration = createAsyncThunk(
  "codeConversion/iteration", iterationApi
)

export const bteqCodeSummary = createAsyncThunk(
  "codeConversion/bteqCodeSummary", bteqCodeSummaryApi
)

export const bteqCodeConversionChunk = createAsyncThunk(
  "codeConversion/bteqCodeConversionChunk", bteqCodeConversionChunkApi
)


export const codeConversionSlice = createSlice({
  name: "CodeConversion",
  initialState,
  reducers: {
    clearState: (state) => {
      state.targetCode = "";
      state.judgeResponse = "";
      state.validationMessage = "";
      state.message = "";
      state.tdd = "";
      state.clonedRepo = [];
      state.fileResults = []
      state.fileContent = [];
    },
    setFileContent: (state, action) => {
      console.log("State: ", action.payload)
      state.fileContent = action.payload
    },
    loadFromSession: (state) => {
      const responseSessionData = JSON.parse(sessionStorage.getItem("code-conversion-response"));
      if(responseSessionData){
        state.targetCode = responseSessionData.target_code || "";
        state.judgeResponse = responseSessionData.judge_response || "";
        state.validationMessage = responseSessionData.validation_message | "";
        state.fileContent = responseSessionData.fileContent | [];
        state.tdd = responseSessionData.tdd || "";
      }
    },
    updateClonedRepo: (state) => {
      state.clonedRepo = []
    },
    setSelectedFileResponse: (state, action) =>{
      console.log("State and action: ", state, action)
      let payload = state.fileContent?.find(file => file.name == action.payload.filename)?.iterations?.find(iter => iter.iteration == action.payload.iteration);
      console.log("Payload value in set files: ", payload)
      if(payload){
        state.targetCode = payload?.target_code;
        state.judgeResponse = payload?.judge_response;
        state.validationMessage = payload?.validation_message;
        state.message = payload?.message;
        state.tdd = payload?.tdd
      }
    },
    stepperLoaderUpdate: (state) => {
      console.log("In Stepper Update")
      state.updateStepperLoad = !state.updateStepperLoad
    }
  },
  extraReducers: (builder) => {
    builder.addCase(convertCode.pending, (state) => {
      console.log("Loading...", state);
      state.loadingMessage = loadingMessages.codeConvert;
      state.loading = true;
      const updatedContent = state.fileContent.map(file => {
        return {
          ...file,
          iterations: file.iterations.map((iteration, index) => {
            if(index == file.currentIteration - 1) {
              return {
                ...iteration,
                status: "inprogress"
              }
            } else {
              return iteration
            }
          })
        }
      })
      state.fileContent = updatedContent
    })
    builder.addCase(convertCode.fulfilled, (state, action) => {
      console.log("Success in convert code: ", state, action.payload);
      const updatedContent = state.fileContent.map(file => {
        const response = action.payload.file_results.find(result => result.filename == file.name)
        if(response && response.iterations){
          return {
            ...file,
            currentIteration: response.iterations.length + 1,
            message: response.iterations[response.iterations.length-1].message,
            iterations: file.iterations.map(iter => {
              const currentIteration = response.iterations.find(current => current.iteration == iter.key)
              if(currentIteration){
                return {
                  ...iter,
                  ...currentIteration,
                  status: "completed"
                }
              } else {
                return {
                  ...iter,
                  status: "pending"
                }
              }
            })
          }
        } else if(response){
          return {
            ...file,
            currentIteration: file.currentIteration + 1,
            message: response?.message,
            source_code: response?.source_code,
            iterations: file.iterations.map((iteration, index) => {
              if(index == file.currentIteration - 1) {
                return {
                  ...iteration,
                  target_code: response?.target_code,
                  judge_response: response?.judge_response,
                  iteration: response?.iteration,
                  validation_message: response?.validation_message,
                  message: response?.message,
                  status: "completed",
                  tdd: response?.tdd
                }
              } else {
                return {
                  ...iteration,
                  status: "pending"
                }
              }
            })
          }
        } else {
          return file
        }
      })
      state.fileContent = updatedContent
      state.targetCode = (action.payload.file_results[0]?.iterations && action.payload.file_results[0]?.iterations[0]?.target_code) || action.payload.file_results[0]?.target_code || "";
      state.judgeResponse = (action.payload.file_results[0]?.iterations && action.payload.file_results[0]?.iterations[0]?.judge_response) || action.payload.file_results[0]?.judge_response || "";
      state.validationMessage = (action.payload.file_results[0]?.iterations && action.payload.file_results[0]?.iterations[0]?.validation_message) || action.payload.file_results[0]?.validation_message || "";
      state.message = (action.payload.file_results[0]?.iterations && action.payload.file_results[0]?.iterations[0]?.message) || action.payload.file_results[0]?.message || "";
      state.sourceCode = (action.payload.file_results[0]?.iterations && action.payload.file_results[0]?.iterations[0]?.source_code) || action.payload.file_results[0]?.source_code || "";
      state.tdd = (action.payload.file_results[0]?.iterations && action.payload.file_results[0]?.iterations[0]?.tdd) || action.payload.file_results[0]?.tdd || "";
      state.iteration = !state.iteration;
      state.loading = false;
      state.loadingMessage = undefined;
    })
    builder.addCase(convertCode.rejected, (state, action) => {
      console.log("Error in Reducer", state, action);
      toast.error(action.error.message)
      const updatedContent = state.fileContent.map(file => {
        return {
          ...file,
          iterations: file.iterations.map((iteration, index) => {
            if(index == file.currentIteration - 1) {
              return {
                ...iteration,
                status: "failed"
              }
            } else {
              return iteration
            }
          })
        }
      })
      state.fileContent = updatedContent
      state.loading = false;
      state.loadingMessage = undefined
    })
    builder.addCase(iteration.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
      state.loadingMessages = loadingMessages.iteration + state.fileContent[0].currentIteration;
      const updatedContent = state.fileContent.map(file => {
        return {
          ...file,
          iterations: file.iterations.map((iteration, index) => {
            if(index == file.currentIteration - 1) {
              return {
                ...iteration,
                status: "inprogress"
              }
            } else {
              return iteration
            }
          })
        }
      })
      state.fileContent = updatedContent
    })
    builder.addCase(iteration.fulfilled, (state, action) => {
      console.log("Success in convert code: ", state, action);
      const { target_code, judge_response, validation_message, message } = action.payload[0];
      state.targetCode = target_code;
      state.judgeResponse = judge_response;
      state.validationMessage = validation_message;
      state.message = message;
      state.loading = false;
      state.loadingMessage = undefined;
      state.iteration = !state.iteration;
      const updatedContent = state.fileContent.map(file => {
        const response = action.payload.find(result => result.filename == file.name)
        console.log("Response Value: ", response)
        if(response){
          return {
            ...file,
            currentIteration: file.currentIteration + 1,
            message: response.message,
            iterations: file.iterations.map((iteration, index) => {
              if(index == file.currentIteration - 1) {
                return {
                  ...iteration,
                  target_code: response.target_code,
                  iteration: file.currentIteration,
                  judge_response: response.judge_response,
                  validation_message: response.validation_message,
                  source_code: response.source_code,
                  message: response.message,
                  tdd: response.tdd,
                  status: "completed"
                }
              } else {
                return iteration
              }
            })
          }
        } else {
          return file
        }
      })
      state.fileContent = updatedContent
      sessionStorage.setItem(
        "code-conversion-response",
        JSON.stringify({
          target_code,
          judge_response,
          validation_message,
          fileContent: updatedContent
        })
      );
    })
    builder.addCase(iteration.rejected, (state, action) => {
      console.log("Error in Reducer", state, action);
      toast.error(action.error.message)
      state.loading = false;
      const updatedContent = state.fileContent.map(file => {
        return {
          ...file,
          iterations: file.iterations.map((iteration, index) => {
            if(index == file.currentIteration - 1) {
              return {
                ...iteration,
                status: "failed"
              }
            } else {
              return iteration
            }
          })
        }
      })
      state.fileContent = updatedContent
      state.loadingMessage = undefined;
    })
    builder.addCase(bteqCodeSummary.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
      state.loadingMessage = loadingMessages.common
    })
    builder.addCase(bteqCodeSummary.fulfilled, (state, action) => {
      console.log("Success in convert code: ", state, action);
      const updatedState = state.fileContent.map(file => {
        const fileDetails = action.payload.find(res => res.file_name == file.name)
        if(fileDetails && fileDetails.message == "call old api"){
          return {
            ...file,
            chunk: false
          } 
        } else if(fileDetails && fileDetails.message == "call new api"){
          return {
            ...file,
            chunk: true,
            bteqSummary: {
              noOfChunks: fileDetails["Number of Chunks"],
              totalTokens: fileDetails["total number of tokens"],
              averageTime: fileDetails["Average Convertion time in hours"]
            }
          }
        } else {
          return file
        }
      })
      state.fileContent = updatedState
      state.bteqChange = !state.bteqChange
      state.loading = false;
      state.loadingMessage = undefined;
    })
    builder.addCase(bteqCodeSummary.rejected, (state, action) => {
      console.log("Error in Reducer", state, action);
      toast.error(action.error.message)
      state.loading = false;
      state.loadingMessage = undefined;
    })
    builder.addCase(bteqCodeConversionChunk.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
      state.loadingMessage = loadingMessages.codeConvert;
    })
    builder.addCase(bteqCodeConversionChunk.fulfilled, (state, action) => {
      console.log("Success in convert code: ", state, action);
      const updatedContent = state.fileContent.map(file => {
        const response = action.payload.file_responses.find(result => result.filename == file.name)
        if(response){
          const targetCodeContent = response.combined_pyspark_code || response.target_code || "";

          return {
            ...file,
            message: response.message || "Success",
            source_code: response.source_code || "",
            iterations: file.iterations.map((iteration) => {
              // if(index == 0) {
              return {
                ...iteration,
                target_code: targetCodeContent,
                judge_response: response.judge_response || "",
                iteration: 1,
                validation_message: response.validation_message || "",
                message: response.message || "",
                status: "completed"
              }
              // } else {
              // return iteration
              // }
            })
          };
        } 
        return file
        
      });

      const firstResponse = action.payload.file_responses[0] || {};

      state.fileContent = updatedContent;
      state.targetCode = firstResponse.combined_pyspark_code || firstResponse.target_code || "";
      state.judgeResponse = firstResponse.judge_response || "";
      state.validationMessage = firstResponse.validation_message || "";
      state.message = "Success";
      state.loading = false;
      state.updateStepperLoad = !state.updateStepperLoad;
      state.loadingMessage = undefined;
    })
    builder.addCase(bteqCodeConversionChunk.rejected, (state, action) => {
      console.log("Error in Reducer", state, action);
      toast.error(action.error.message)
      state.loading = false;
      state.loadingMessage = undefined
    })
    builder.addCase(githubLink.fulfilled, (state, action) => {
      console.log("Success in convert code: ", state, action);
      state.clonedRepo = action.payload.scripts
      state.loadingMessage = undefined
    })
    builder.addCase(githubLink.rejected, (state, action) => {
      console.log("Error in Reducer", state, action);
      toast.error(action.error.message)
      state.loading = false;
      state.loadingMessage = undefined
    })
    builder.addCase(githubLink.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
      state.loadingMessage = loadingMessages.common;
    })
  }
})

export const { clearState, loadFromSession, updateClonedRepo, stepperLoaderUpdate, resetBteqChunk, setSelectedFileResponse, setFileContent } = codeConversionSlice.actions;

export default codeConversionSlice.reducer